import React, { useState } from 'react';
import {
    Box, Typography, Button, Select, MenuItem, FormControl, InputLabel, Grid, Table,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField
} from '@mui/material';

const EnviarInformacoes = () => {
    const [ano, setAno] = useState('');
    const [mes, setMes] = useState('');
    const [dadosEmpresas, setDadosEmpresas] = useState(null);
    const [email, setEmail] = useState('');

    const monthMapping = {
        Janeiro: 1, Fevereiro: 2, Março: 3, Abril: 4, Maio: 5, Junho: 6,
        Julho: 7, Agosto: 8, Setembro: 9, Outubro: 10, Novembro: 11, Dezembro: 12,
    };

    const handleAnoChange = (event) => setAno(event.target.value);
    const handleMesChange = (event) => setMes(event.target.value);
    const handleEmailChange = (event) => setEmail(event.target.value);

    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local


    const gerarInformacoes = async () => {
        try {
            const response = await fetch(`${apiBaseURL}/api/gerar_informacoes/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ year: ano, month: monthMapping[mes] }),
            });
    
            if (!response.ok) throw new Error("Erro na solicitação");
            const { dadosEmpresas } = await response.json();
            setDadosEmpresas(dadosEmpresas);
        } catch (error) {
            console.error('Erro ao gerar informações:', error);
        }
    };

    const enviarEmail = async () => {
        try {
            const response = await fetch(`${apiBaseURL}/api/send_email/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, table_data: dadosEmpresas }), // Ensure key is table_data
            });
            if (!response.ok) throw new Error("Erro ao enviar email");
            alert("Email enviado com sucesso!");
        } catch (error) {
            console.error('Erro ao enviar email:', error);
        }
    };
    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h6" align="center" gutterBottom>Enviar Informações ao Contabilista</Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={6}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Ano</InputLabel>
                        <Select value={ano} onChange={handleAnoChange}>
                            <MenuItem value={2027}>2027</MenuItem>
                            <MenuItem value={2026}>2026</MenuItem>
                            <MenuItem value={2025}>2025</MenuItem>
                            <MenuItem value={2024}>2024</MenuItem>
                            <MenuItem value={2023}>2023</MenuItem>
                            <MenuItem value={2023}>2023</MenuItem>
                            <MenuItem value={2021}>2021</MenuItem>
                            <MenuItem value={2020}>2020</MenuItem>
                            <MenuItem value={2019}>2019</MenuItem>
                            <MenuItem value={2018}>2018</MenuItem>
                            <MenuItem value={2017}>2017</MenuItem>
                            <MenuItem value={2016}>2016</MenuItem>
                            <MenuItem value={2015}>2015</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Mês</InputLabel>
                        <Select value={mes} onChange={handleMesChange}>
                            {Object.keys(monthMapping).map((month) => (
                                <MenuItem key={month} value={month}>{month}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Button variant="contained" color="primary" onClick={gerarInformacoes} sx={{ mt: 2 }}>
                    Gerar informações
                </Button>
            </Grid>

            {/* Renderizar a tabela de dados das empresas */}
            {dadosEmpresas && typeof dadosEmpresas === 'object' && Object.keys(dadosEmpresas).map((empresa) => (
                <Box key={empresa} mb={4}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>{empresa}</Typography>
                    <TableContainer component={Paper} sx={{ mt: 2, boxShadow: 3, borderRadius: 2, overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Funcionário</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Horário Trabalho</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Mês</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Faltas</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Horas Extra</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Férias</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Observações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(dadosEmpresas[empresa]) ? (
                                    dadosEmpresas[empresa].map((funcionario, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{funcionario.nome}</TableCell>
                                            <TableCell dangerouslySetInnerHTML={{ __html: funcionario.horario_trabalho || '-' }} />                                            <TableCell>{funcionario.mes}</TableCell>
                                            <TableCell dangerouslySetInnerHTML={{ __html: funcionario.faltas || '-' }} />
                                            <TableCell dangerouslySetInnerHTML={{ __html: Array.isArray(funcionario.horas_extras) ? funcionario.horas_extras.join('<br>') : funcionario.horas_extras || '-' }} />
                                            <TableCell>{funcionario.ferias || '-'}</TableCell>
                                            <TableCell>{funcionario.observacoes || '-'}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={7}>Erro: dados de funcionários inválidos para {empresa}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ))}

            {/* Campo para inserir email e botão para enviar, exibidos apenas após gerar informações */}
            {dadosEmpresas && (
                <Box mt={4}>
                    <TextField
                        label="Email"
                        value={email}
                        onChange={handleEmailChange}
                        fullWidth
                        margin="normal"
                    />
                    <Button variant="contained" color="secondary" onClick={enviarEmail} sx={{ mt: 2 }}>
                        Enviar Email
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default EnviarInformacoes;
